// DEMO: iframe overlay on video — remove this entire file when done

import logger from "@/lib/logger"

const STORAGE_KEY = 'LD_OVERLAY'

export function installOverlayRouterGuard(router) {
  router.beforeEach((to, from, next) => {
    const query = to.query
    const hasOverlayParams = query.ld_overlay_nuke
      || query.ld_overlay_url
      || query.ld_overlay_height
      || query.ld_overlay_width
      || query.ld_overlay_patient_id

    if (hasOverlayParams) {
      if (query.ld_overlay_nuke) {
        localStorage.removeItem(STORAGE_KEY)
      } else {
        const overlay = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{"global":null,"patients":{}}')
        const pid = query.ld_overlay_patient_id ? String(query.ld_overlay_patient_id) : null
        let existing
        if (pid) {
          overlay.patients = overlay.patients || {}
          existing = overlay.patients[pid] || {}
        } else {
          existing = overlay.global || {}
        }
        const config = { height: 80, width: 100, ...existing }
        if (query.ld_overlay_url) config.url = query.ld_overlay_url
        if (query.ld_overlay_height) config.height = parseInt(query.ld_overlay_height) || config.height
        if (query.ld_overlay_width) config.width = parseInt(query.ld_overlay_width) || config.width
        if (pid) {
          overlay.patients[pid] = config
        } else {
          overlay.global = config
        }
        localStorage.setItem(STORAGE_KEY, JSON.stringify(overlay))
      }

      const cleanQuery = { ...query }
      delete cleanQuery.ld_overlay_url
      delete cleanQuery.ld_overlay_height
      delete cleanQuery.ld_overlay_width
      delete cleanQuery.ld_overlay_patient_id
      delete cleanQuery.ld_overlay_nuke
      return next({ path: to.path, query: cleanQuery, hash: to.hash, replace: true })
    }

    next()
  })
}

export function resolveOverlayConfig(patientId) {
  const raw = localStorage.getItem(STORAGE_KEY)
  if (!raw) return null
  try {
    const overlay = JSON.parse(raw)
    const pid = String(patientId || '')
    const patient = pid ? overlay.patients?.[pid] : null
    if (!patient && !overlay.global) return null
    return { ...(overlay.global || {}), ...(patient || {}) }
  } catch (e) {
    logger.warn('failed to parse LD_OVERLAY config', e)
  }
  return null
}

export function buildOverlayIframeSrc(config, patientId, monitorId) {
  if (!config?.url) return null
  try {
    const url = new URL(config.url)
    if (patientId) url.searchParams.set('patient_id', patientId)
    if (monitorId) url.searchParams.set('monitor_id', monitorId)
    return url.toString()
  } catch {
    return config.url
  }
}
